/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Flex, Pane, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './ErrorComponent.css';
const {
  t,
  tIcon
} = I18N.ns('login.ErrorComponent');
export default function ErrorComponent(props) {
  const {
    variant,
    className,
    error
  } = props;
  const errorText = error?.errorCode ? t(error.errorCode, error.message) : error ? t('loginError', error.message) : null;
  return /*#__PURE__*/React.createElement(Pane, {
    className: classnames(className, !errorText ? S.transparent : ''),
    variant: variant
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: `${variant}|rowM`
  }, /*#__PURE__*/React.createElement(Text, {
    icon: tIcon('icon.error'),
    className: S.errorText,
    variant: variant
  }, errorText)));
}
ErrorComponent.propTypes = {
  variant: PropTypes.string,
  className: PropTypes.string,
  error: PropTypes.exact({
    message: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    errorCode: PropTypes.string
  })
};